<template>
  <div>
    <img
      v-if="this.imagenDelRostroBase64"
      class="img-thumbnail"
      :src="'data:image/jpg;base64,' + this.imagenDelRostroBase64"
      alt="Foto de la persona"
      download
    />
    <i
      v-else
      style="font-size:6em;"
      title="Sin foto de la persona"
      class="far fa-user-circle"
    ></i>

    <div
      v-if="this.conBotonDeSubidor || this.conBotonDeDescarga"
      class="d-flex justify-content-around"
    >
      <div v-if="this.conBotonDeSubidor" >
        <label for="fotoNueva">
          <i
            :v-if="this.personaId"
            for="fotoNueva"
            title="Cambiar foto de la persona"
            class="fas fa-camera label-black"
            style="cursor:pointer;"
          ></i>
        </label>
        <input
          @change="SubirImagen"
          type="file"
          id="fotoNueva"
          name="fotoNueva"
          accept="image/png, image/jpeg, image/jpg"
          hidden
        />
      </div>

      <div v-if="this.conBotonDeDescarga" class="btn-descarga">
        <a
          :download="this.personaId + '.jpg'"
          :href="'data:image/jpg;base64,' + this.imagenDelRostroBase64"
          :disabled="this.imagenDelRostroBase64 == null"
        >
          <i title="Descargar imagen" class="fas fa-download"></i>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/../static/js/api";
import axios from "axios";
import comun from "@/../static/js/comun";

export default {
  mounted: function() {
    if(this.personaId > 0){
      this.CargarImagen(this.personaId);
    }
    
  },
  props: [
    "personaId"
    , "conBotonDeDescarga"
    , "conBotonDeSubidor"
    
    ],
  data() {
    return {  
      imagenDelRostroBase64:null
    };
  },
  methods: {
    CargarImagen(personaId) {
      comun.SeEstaCargandoInformacion(true);
      let peticion = {
        PersonaId:personaId  
      };
      axios
        .post(
          api.conexion + api.SIAP.funcion.GetImagenDeRostroBase64,
          peticion,
          comun.CrearElHeaderDeAutorizacion(
            this.$store.state.Login_AutorizacionOriginal
          )
        )
        .then(response => {
          if (response.data.SiHayError == false) {
            //Pasa la información de la respuesta al modelo que usa el componente
            this.imagenDelRostroBase64 = response.data.ImagenDeRostroBase64;
          } else {
            console.log(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
          }
          comun.SeEstaCargandoInformacion(false);
        })
        .catch(e => {
          console.error(e);
          comun.mensajeDeAlerta(
            comun.mensajeDeError(enumeraciones.error.E500),
            null,
            null
          );
          comun.SeEstaCargandoInformacion(false);
        });
    },
    SubirImagen(event) {
      comun.SeEstaCargandoInformacion(true);

      // Se carga la imagen al formulario.
      var datosDelFormulario = new FormData();
      datosDelFormulario.set("PersonaId", this.personaId);
      datosDelFormulario.append("image", event.target.files[0]);

      // Elimina la foto para evitar usandola
      this.imagenDelRostroBase64 = null;

      axios
        .post(
          api.conexion + api.SIAP.funcion.GuardarImagen,
          datosDelFormulario,
          comun.CrearElHeaderDeAutorizacion(
            this.$store.state.Login_AutorizacionOriginal,
            true
          )
        )
        .then(respuesta => {
          console.log(respuesta);
          if (respuesta.data.SiHayError) {
            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
          } else {
            comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
            this.imagenDelRostroBase64 = respuesta.data.ImagenDataEnBytes;
          }
          comun.SeEstaCargandoInformacion(false);
        })
        .catch(excepcion => {
          console.log(excepcion);
          comun.mensajeDeAlerta(
            comun.mensajeDeError(enumeraciones.error.E500),
            null,
            null
          );
          comun.SeEstaCargandoInformacion(false);
        });
    }
  }
};
</script>
<style>
div.btn-descarga a{
  color:#0e0d0d;
}
.label-black {
        color: black;
    }
</style>



// WEBPACK FOOTER //
// src/components/SIAP/Comun/RostroDePersona.vue